import MuiDialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import { XIcon } from '@phosphor-icons/react/X';
import type { ReactNode, SyntheticEvent } from 'react';

export type DialogTitleProps = {
  children?: ReactNode;
  dataTest?: string;
  onClose?: (e: SyntheticEvent<HTMLElement>) => void;
  onCloseDisabled?: boolean;
};

export const DialogTitle = ({
  children,
  dataTest = 'modal-title',
  onClose,
  onCloseDisabled = false,
}: DialogTitleProps) => (
  <Stack
    data-test={dataTest}
    direction="row"
    sx={{
      alignItems: 'center',
      justifyContent: 'space-between',
    }}
  >
    <MuiDialogTitle>{children}</MuiDialogTitle>

    {onClose && (
      <IconButton aria-label="Close dialog" disabled={onCloseDisabled} onClick={onClose} size="large" sx={{ mr: 2 }}>
        <XIcon data-test="close-dialog" />
      </IconButton>
    )}
  </Stack>
);
